<template>
  <div>
    <div class="nav-search relative flex flex-wrap mb-3">
      <div class="w-full justify-between flex flex-auto">
        <div>
          <h1
            class="inline-block"
            id="title"
            v-if="$route.name === 'NotesSearch' || $route.name === 'Discover'"
          >
            <span
              @click="$router.go(-1)"
              class="cursor-pointer inline-block relative"
              style="top: 4px"
            >
              <Zondicon
                class="w-6 fill-current cursor-pointer"
                icon="CheveronLeft"
              />
            </span>
            <span>
              Notes
            </span>
          </h1>
          <h1 class="inline-block" v-else-if="$route.name === 'UserBook'">
            <span
              @click="$router.go(-1)"
              class="cursor-pointer inline-block relative"
              style="top: 4px"
            >
              <Zondicon
                class="w-6 fill-current cursor-pointer"
                icon="CheveronLeft"
              />
            </span>
            <span v-if="author">
              {{ book.name }} by
              <router-link :to="`/u/${$route.params.user}`">
                {{ author.name }}
              </router-link>
            </span>
            <span v-else>Author</span>
          </h1>
          <h1 class="inline-block" v-else-if="$route.name === 'UserNote'">
            <span
              @click="$router.go(-1)"
              class="cursor-pointer inline-block relative"
              style="top: 4px"
            >
              <Zondicon
                class="w-6 fill-current cursor-pointer"
                icon="CheveronLeft"
              />
            </span>
            <span v-if="author">
              <router-link
                :to="`/u/${$route.params.user}/${$route.params.book}`"
              >
                {{ book.name }}
              </router-link>
              by
              <router-link :to="`/u/${$route.params.user}`">
                {{ author.name }}
              </router-link>
            </span>
            <span v-else>Author</span>
          </h1>
          <h1 v-else-if="$route.name === 'NotesFavs'">
            Favorites
          </h1>
        </div>
        <div class="flex">
          <div
              class="text-blue inline-block cursor-pointer"
          >
            <router-link :to="{ path: '/' }" class="inline-block cursor-pointer">
              <Zondicon class="nav-icon w-8 fill-current" icon="Home" />
            </router-link>
            <router-link
                :to="{ path: '/notes' }"
                class="inline-block cursor-pointer"
            >
              <Zondicon class="nav-icon w-8 fill-current" icon="Globe" />
            </router-link>
          </div>
          <div class="text-blue inline-block cursor-pointer relative">
            <router-link
                class="inline-block cursor-pointer"
              title="Notes from your favorite authors and books"
              to="/notes/favs"
              v-if="$route.name !== 'NotesFavs'"
            >
              <Zondicon class="nav-icon h-8 fill-current" icon="StarFull" />
            </router-link>
            <router-link
                class="inline-block cursor-pointer"
              title="Browse all notes"
              to="/notes"
              v-else-if="$route.name === 'NotesFavs'"
            >
              <Zondicon class="nav-icon h-8 fill-current" icon="Globe" />
            </router-link>
          </div>
          <div
              class="text-blue inline-block cursor-pointer"
              id="search-dropdown-button"
              title="Search all public notes"
              v-on:click="displaySearch"
          >
            <Zondicon class="nav-icon w-8 fill-current" icon="Search" />
          </div>
        </div>
      </div>
    </div>

    <div class="relative">
      <div class="search w-full" v-if="showSearch">
        <public-search-dropdown class="block"></public-search-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import PublicSearchDropdown from "./PublicSearchDropdown";

export default {
  components: {
    PublicSearchDropdown
  },
  // props: ['handleSearchSubmit'],
  methods: {
    displaySearch(e) {
      e.stopPropagation(); // stop outside click from closing dropdown
      this.$store.dispatch("aShowSearch", { show: !this.showSearch });
    }
  },
  computed: {
    author() {
      return this.$store.state.notes.author;
    },
    book() {
      return this.$store.state.notes.book;
    },
    showSearch() {
      console.log("showSearch", this.$store.state.notes.showSearch);
      return this.$store.state.notes.showSearch;
    },
    note() {
      // if we are on a single note page, return the single note
      if (this.$route.params.note) {
        const noteId = parseInt(this.$route.params.note);
        const index = this.$store.state.notes.notes.findIndex(
          x => x.id === noteId
        );
        return this.$store.state.notes.notes[index];
      }
      return null;
    }
  }
};
</script>

<style lang="scss"></style>
